import React from "react";
import { Icons } from "../../shared/Icons";

interface BalanceUnpaidRowProps {
  onPay: () => void;
  children: React.ReactNode;
}

export const BalanceUnpaidRow: React.FC<BalanceUnpaidRowProps> = ({ onPay, children }) => (
  <div className="bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-800 rounded-lg p-3 sm:p-4 hover:shadow-md transition-shadow">
    <div className="flex items-start justify-between gap-2">
      <div className="flex-1 min-w-0">{children}</div>
      <button
        type="button"
        onClick={onPay}
        className="flex-shrink-0 px-2 sm:px-3 py-1 text-xs sm:text-sm bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 text-slate-800 dark:text-slate-100 border border-slate-300 dark:border-slate-500 hover:border-slate-400 transition-colors rounded-md shadow-sm flex items-center gap-1"
        title="Adicionar pagamento"
      >
        <Icons.Payment sx={{ fontSize: 16 }} />
        <span className="hidden sm:inline">Pagar</span>
      </button>
    </div>
  </div>
);
